// extracted by mini-css-extract-plugin
export default {"container":"CopyQuoteLinkButton_container__gG6TB","linkIcon":"CopyQuoteLinkButton_linkIcon__USyqZ","copied":"CopyQuoteLinkButton_copied__zydJG"};